/** Rotas centralizadas — evita string literal espalhada em Link/navigate. */
export const ROUTES = {
  login: '/login',
  forgotPassword: '/recuperar-senha',
  resetPassword: '/redefinir-senha',
  invite: '/convite',

  home: '/',
  projects: '/projetos',
  project: (id = ':projectId') => `/projetos/${id}`,
  projectBoard: (id = ':projectId') => `/projetos/${id}/board`,
  projectTable: (id = ':projectId') => `/projetos/${id}/tabela`,
  projectCalendar: (id = ':projectId') => `/projetos/${id}/calendario`,
  projectTeam: (id = ':projectId') => `/projetos/${id}/equipe`,

  timesheet: '/apontamentos',
  timesheetAudit: '/apontamentos/auditoria',

  admin: '/admin',
  adminUsers: '/admin/usuarios',
  adminSpaces: '/admin/espacos',
  adminSettings: '/admin/configuracoes',

  portfolio: '/portfolio',

  forbidden: '/403',
  notFound: '/404',
} as const;
